import React, { useEffect, useState } from 'react'
import { Flex } from '@src/components/Boxes'
import { Link } from 'gatsby'
import { H4 } from '@src/components/Text'
import styled from '@emotion/styled'

const LinkText = styled.span`
  color: #777;
  font-family: proxima-nova, 'Helvetica Neue', Helvetica, Arial, sans-serif;

  &:hover {
    color: #00bcf2;
    text-decoration: none;
  }
`

const ResultList = ({ results, query, closeSearch }) => {
  function getPostPath(post) {
    if (post.for_website === 'dev-blog') {
      const date = post.publish_date.split('-')
      return `/${date[0]}/${date[1]}/${date[2]}/${post.slug}`
    } else return `/${post.slug}`
  }
  if (results.length > 0) {
    return results.slice(0, 10).map((page, i) => (
      <div key={i}>
        <Link to={getPostPath(page)} onClick={closeSearch}>
          <H4>
            <LinkText>{page.title}</LinkText>
          </H4>
        </Link>
      </div>
    ))
  } else if (query.length > 2) {
    return <H4>{'No results for ' + query}</H4>
  } else if (results.length === 0 && query.length > 0) {
    return <H4>'Please insert at least 3 characters'</H4>
  } else {
    return null
  }
}

type BlogSearchFormProps = {
  closeSearch: () => void
}
const BlogSearchForm: React.FC<BlogSearchFormProps> = ({ closeSearch }) => {
  const [query, setQuery] = useState<string>('')
  const [results, setResults] = useState<Array<object>>([])

  const getSearchResults = query => {
    const index = (window as any).__FLEXSEARCH__.en.index
    const store = (window as any).__FLEXSEARCH__.en.store
    if (!query || !index) {
      return []
    } else {
      let results = []
      // search the indexed fields
      Object.keys(index).forEach(idx => {
        results.push(...index[idx].values.search(query)) // more search options at https://github.com/nextapps-de/flexsearch#index.search
      })

      // find the unique ids of the nodes
      results = Array.from(new Set(results))

      // return the corresponding nodes in the store
      const nodes = store.filter(node => (results.includes(node.id) ? node : null)).map(node => node.node)

      return nodes
    }
  }

  const search = () => {
    if (query.length > 2) {
      const results = getSearchResults(query)
      setResults(results)
    } else {
      setResults([])
    }
  }

  return (
    <Flex flexDirection="column">
      <Flex alignItems="center" justifyContent="center" maxWidth={'560px'} width={'80%'} mx="auto" minHeight="65px">
        <input
          type="text"
          value={query}
          onChange={event => {
            setQuery(event.target.value)
            search()
          }}
          placeholder={'search here ...'}
        />
      </Flex>
      {results && results.length > 0 && (
        <Flex flexDirection="column" marginBottom="20px">
          <ResultList results={results} query={query} closeSearch={closeSearch} />
        </Flex>
      )}
    </Flex>
  )
}

export default BlogSearchForm
